/// <reference types="google.maps" />

import { Injectable } from '@angular/core';
import { Address } from '@models/Address';
import { Observable, Subject } from 'rxjs';

interface PlaceAddress {
	address: Address;
	businessName: string;
}

@Injectable({
	providedIn: 'root',
})
export class PlacesService {

	private readonly defaultPlaceOptions: google.maps.places.AutocompleteOptions = {
		componentRestrictions: { country: `us` },
		fields: [`address_components`],
	};

	constructor() { }

	public initAutocomplete(
		input: HTMLInputElement,
		options?: google.maps.places.AutocompleteOptions,
	): Observable<PlaceAddress> {
		const ϴϴresult: Subject<PlaceAddress> = new Subject();
		const result: Observable<PlaceAddress> = ϴϴresult.asObservable();
		const autocompleteEl = new google.maps.places.Autocomplete(input, { ...this.defaultPlaceOptions, ...options });
		autocompleteEl && autocompleteEl.addListener(`place_changed`, () => {
			const place = autocompleteEl.getPlace();
			if (place?.address_components?.length) {
				const component = <google.maps.GeocoderAddressComponent[]>place.address_components;
				const getComponentValue = (fieldName: string) => component.find(c => c.types.includes(fieldName));
				const houseNumber = getComponentValue(`street_number`)?.short_name;
				const street = getComponentValue(`route`)?.long_name;
				const placeResult: PlaceAddress = {
					address: {
						addressLine1: houseNumber ? `${houseNumber} ${street}` : `${street}`,
						aptUnit: ``,
						city: getComponentValue(`locality`)?.long_name ?? getComponentValue(`sublocality_level_1`)?.long_name ?? ``,
						state: getComponentValue(`administrative_area_level_1`)?.short_name ?? ``,
						zipCode: getComponentValue(`postal_code`)?.long_name ?? ``,
					},
					businessName: place.name ?? ``,
				};

				ϴϴresult.next(placeResult);
			}
		});

		return result;
	}
}
